import React from 'react';
import { SortableLabel, Table } from '../index';
import { Label, TableBody, TableHeader, TableRow } from '../../atoms';
import { SortBy } from '../../../store/landscapeAPI/landscape/dto/request/all-landscapes.dto';
import { SortConfig } from '../../../utils/types/types';

interface SortableTableProps<T> {
  data: T[];
  columns: Array<{
    label: string;
    key?: keyof T; // Optional key for empty columns
    sortKey?: string;
  }>;
  renderRow: (item: T, index: number) => React.ReactNode;
  showEditButtonHeader?: boolean;
  showDeleteButtonHeader?: boolean;
  showDownloadButtonHeader?: boolean;
  sortConfig: SortConfig;
  setSortConfig: (value: SortConfig) => void;
}

type SortDirection = 'asc' | 'desc';

const ServerSortableTable = <T,>({
  data,
  columns,
  renderRow,
  sortConfig,
  setSortConfig,
  showEditButtonHeader = true,
  showDeleteButtonHeader = true,
  showDownloadButtonHeader = false,
}: SortableTableProps<T>) => {
  const requestSort = (key: SortBy) => {
    let direction: SortDirection = 'asc';
    if (
      sortConfig &&
      sortConfig.key === key &&
      sortConfig.direction === 'asc'
    ) {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };

  return (
    <Table>
      <TableHeader>
        <TableRow header={true}>
          {columns.map((column, idx) =>
            column.key && column.sortKey ? (
              <SortableLabel
                key={idx}
                content={column.label}
                onClick={() => requestSort(column.sortKey as SortBy)}
                sortDirection={
                  sortConfig?.key === column.key ? sortConfig.direction : null
                }
              />
            ) : !column.sortKey ? (
              <Label key={idx} content={column.label} bold />
            ) : (
              <Label key={idx} content="" />
            )
          )}
          {showEditButtonHeader && <Label />}
          {showDeleteButtonHeader && <Label />}
          {showDownloadButtonHeader && <Label />}
        </TableRow>
      </TableHeader>
      <TableBody>{data.map((item, index) => renderRow(item, index))}</TableBody>
    </Table>
  );
};

export default ServerSortableTable;
